import React from 'react';
import CircleExclamationPoint from '@uber/base-icons/circle-exclamation-point';
export const BANNER_TEXT = <>
    <CircleExclamationPoint title="Warning" /> For the best results, please use <b>Google Chrome</b>{' '}
    to access this tool.
  </>;